import axios from 'axios';

export const getEoiUser = (uuid) =>
    axios.get(`public/eoi-user/${uuid}`)
        .then(({ data }) => data);

export const getNewEoiUser = (slug, is_sophisticated, utm_source) =>
    axios.get(`public/eoi-user/new/${slug}?is_sophisticated=${is_sophisticated}&utm_source=${utm_source}`)
        .then(({ data }) => data);

export const storeEoiRegistrationPersonalDetails = (params, uuid) =>
    axios.post(`public/eoi-user/${uuid}/personal`, params)
        .then(({ data }) => data);

export const storeEoiRegistrationEntityDetails = (params, uuid) =>
    axios.post(`public/eoi-user/${uuid}/entity`, params)
        .then(({ data }) => data);

export const checkHin = (value, uuid) =>
    axios.post(`public/eoi-user/${uuid}/check-hin`, { hin_number: value })
        .then(({ data }) => data);

export const storeEoiContractNote = (params, uuid) =>
    axios.post(`public/eoi-user/${uuid}/contract-note`, params)
        .then(({ data }) => data)

export const storeEoiCertificate = (params, uuid) =>
    axios.post(`public/eoi-user/${uuid}/certificate`, params)
        .then(({ data }) => data)